<template>
  <div></div>
</template>

<script>
import urlConfig from '@/config'

export default {
  beforeRouteEnter(to, from, next) {
    console.log(111)
    if (!to.query.openId) {
      location.replace(`${urlConfig.kidAppGateway}/kids/api/wxmp/mp/web/auth/learning/center/userinfo?redirect=${encodeURIComponent(location.href)}&needLogin=false&needToken=true`);
    } else {
      location.replace(`${location.origin}/new-pay-wx?learnOpenId=${to.query.openId}`)
    }
  },
}
</script>
